import React, { useEffect, useRef, useState } from 'react';
import { Star } from 'lucide-react';

export const ReviewsCarousel = () => {
  const reviews = [
    {
      id: 1,
      name: 'Rajendra Pandey',
      stars: 5,
      review: 'Raj Canine Care is the best place for the treatment of pets. My pet dog was about to collapse and I had knocked several pet clinics in Vadodara. But everywhere I was cheated. Finally I came to Raj Canine Care. Dr. Rajesh Patel has given a new life to my pet. I salute him for his caring approach. This is the best clinic for pets.'
    },
    {
      id: 2,
      name: 'Kuldip Raj',
      stars: 4,
      review: 'Overall great experience. Well trained grooming staff and My pets health improve after their guidance and treatment.'
    },
    {
      id: 3,
      name: 'Karan Pandya',
      stars: 5,
      review: 'Great staff and very good treatment.. We get proper answer about our dogs condition.'
    },
    {
      id: 4,
      name: 'Kulin Shastri',
      stars: 5,
      review: 'Excellent canin care For Dog Grooming & one of the senior veterinary practitioner in Baroda with all necessary facilities.'
    },
    {
      id: 5,
      name: 'Esha Gossallia',
      stars: 4,
      review: 'Its good grooming place for pets.. they have huge variety of pet products and vet is available in house.. only in summers it is too hot as the grooming area does not have AC n if haircuts are on thn they have to switch the fans also off.. staff is good..'
    }
  ];

  const containerRef = useRef(null);
  const scrollRef = useRef(0);
  const [isPaused, setIsPaused] = useState(false);
  const [hoveredId, setHoveredId] = useState(null);

  // Create a duplicated list for infinite scroll effect
  const duplicatedReviews = [...reviews, ...reviews];

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    let animationId;
    const scrollSpeed = 1; // pixels per frame
    const cardWidth = 340; // w-80 (320px) + gap (20px)
    const singleSetWidth = cardWidth * reviews.length;

    const scroll = () => {
      // Only scroll if not paused
      if (!isPaused) {
        scrollRef.current += scrollSpeed;
        
        // Reset to beginning seamlessly when reaching the duplicated section
        if (scrollRef.current >= singleSetWidth) {
          scrollRef.current = 0;
        }

        container.scrollLeft = scrollRef.current;
      }
      
      animationId = requestAnimationFrame(scroll);
    };

    animationId = requestAnimationFrame(scroll);

    return () => cancelAnimationFrame(animationId);
  }, [isPaused, reviews.length]);

  return (
    <section id="reviews-carousel" className="py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
            What Our Customers Say
          </h2>
          <div className="w-24 h-1 bg-yellow-400 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Hear from our happy pet parents about their experience with Raj Canine Care
          </p>
        </div>

        {/* Scrolling Reviews Container */}
        <div ref={containerRef} className="overflow-x-hidden pb-4">
          <div className="flex gap-6 px-4">
            {duplicatedReviews.map((review, index) => (
              <div
                key={`${review.id}-${index}`}
                className={`flex-shrink-0 w-80 bg-white rounded-2xl shadow-lg p-8 transition-all duration-300 ${
                  hoveredId === review.id ? 'scale-110 shadow-2xl' : 'hover:shadow-xl'
                }`}
                onMouseEnter={() => {
                  setHoveredId(review.id);
                  setIsPaused(true);
                }}
                onMouseLeave={() => {
                  setHoveredId(null);
                  setIsPaused(false);
                }}
              >
                {/* Customer Name - First */}
                <div className="mb-6">
                  <p className="font-semibold text-gray-900 text-lg">
                    {review.name}
                  </p>
                  <p className="text-xs text-gray-500">Verified Customer</p>
                </div>

                {/* Stars */}
                <div className="flex items-center gap-2 mb-4">
                  {[...Array(review.stars)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-5 h-5 text-yellow-400 fill-yellow-400"
                    />
                  ))}
                </div>

                {/* Review Text */}
                <p className="text-gray-700 text-sm leading-relaxed min-h-20">
                  "{review.review}"
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
